import { GroupedTheme, TransformedTheme } from '../../types'

/**
 * Group theme tokens by category.
 * @param theme
 * @returns
 */
export const groupTheme = (theme: TransformedTheme): GroupedTheme => {
  const result: GroupedTheme = {}

  const flattenObject = (obj: Record<string, unknown>, path: string[] = []) => {
    Object.entries(obj).forEach(([key, value]) => {
      const currentPath = [...path, key]

      if (typeof value === 'object' && value !== null) {
        if ('value' in value) {
          const groupKey = currentPath[0]
          const tokenKey = currentPath.slice(1).join('-')

          if (!result[groupKey]) {
            result[groupKey] = {}
          }

          // @ts-ignore
          result[groupKey][tokenKey] = value
        } else {
          flattenObject(value as Record<string, unknown>, currentPath)
        }
      }
    })
  }

  Object.entries(theme).forEach(([category, items]) => {
    flattenObject(items as Record<string, unknown>, [category])
  })

  return result
}
